import { DraftEmail, EncounterDraftEmail, ReferralDraftEmail, SentEmail, TemplateEmail } from "../../models/email-message";
import { User } from "../../models/user";


export namespace Emails
{
    export class UserLoggedIn
    {
        static readonly type = "[Email Login Action] Successful Login";
        constructor(public payload: { user: User }) {}
    }

    export class EmailServiceEncounterEmailDraftAdded
    {
        static readonly type = "[Email Service] Encounter Email draft added";
        constructor(public payload: {draftEmail: EncounterDraftEmail}) {}
    }

    export class EmailServiceReferralEmailDraftAdded
    {
        static readonly type = "[Email Service] Referral Email draft added";
        constructor(public payload: {draftEmail: ReferralDraftEmail}) {}
    }

    export class EmailServiceEmailDraftUpdated
    {
        static readonly type = "[Email Service] Email draft updated";
        constructor(public payload: {draftEmail: DraftEmail}) {}
    }

    export class EmailServiceEmailDraftSent
    {
        static readonly type = "[Email Service] Email draft sent";
        constructor(public payload: {draftEmailId: number}) {}
    }

    export class EmailServiceEmailDraftDeleted
    {
        static readonly type = "[Email Service] Email draft deleted";
        constructor(public payload:{draftEmailId: number}){};
    }

    export class EmailSent
    {
        static readonly type = "[Email Action] Email sent";
        constructor(public payload: { email: SentEmail, emailContext: string}) {}
    }
    

    export class EmailServiceEmailReceivedRead
    {
        static readonly type="[Email Serivce] Email Received Read";
        constructor(public payload:{emailId: number}){};
    }


    export class EmailServiceEmailUpdated
    {
        static readonly type="[Email Service] Email Updated";
        constructor(public payload:{email: SentEmail}){};
    }

    export class PersistState
    {
        static readonly type="[Email State] Persist";
    }

    
}